import { render, staticRenderFns } from "./PostSroMainHomeNotDelivered.vue?vue&type=template&id=410f1184"
import script from "./PostSroMainHomeNotDelivered.vue?vue&type=script&lang=js"
export * from "./PostSroMainHomeNotDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports